import { useI18n } from "vue-i18n";
/**
 * Accessible-name strings for the organisation duplicate-detection result cards
 * (`OrganisationDedupPanel`). Structurally follows the reception module's
 * `useCandidateAccessibleName` (identity fragment dropped cleanly when the
 * disambiguating detail is absent — here the address or city, since
 * organisations have no date of birth), but NOT its "Label in Name" rule:
 * here the accessible name must START WITH the button's visible label (not
 * just contain it), so `previewAriaLabel`/`viewRecordAriaLabel` MUST stay
 * verb-first in every locale, including nl — unlike reception's own
 * `*AriaLabel` keys, which only require containment so nl can put the verb
 * last (`{name} selecteren`).
 */
const A11Y_PREFIX = "organisation.create.dedup";
export const ORGANISATION_DEDUP_A11Y_KEYS = {
    preview: `${A11Y_PREFIX}.previewAriaLabel`,
    viewRecord: `${A11Y_PREFIX}.viewRecordAriaLabel`,
    identityWithLocation: `${A11Y_PREFIX}.identityWithLocation`,
};
export function useOrganisationDedupAccessibleName() {
    const { t } = useI18n();
    /**
     * `<action> <legalName>[, <address or city>]` — the location is dropped
     * entirely when the candidate has none, so the name never trails a dangling
     * separator.
     */
    function dedupResultAccessibleName(actionKey, legalName, location) {
        const identity = location
            ? t(ORGANISATION_DEDUP_A11Y_KEYS.identityWithLocation, { name: legalName, location })
            : legalName;
        return t(actionKey, { name: identity });
    }
    return { dedupResultAccessibleName };
}
